module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/index/weiimg.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "peowei"
  }, [_vm._v("管家微信：yunzhitugj")]), _vm._v(" "), _c('p', {
    staticClass: "phone"
  }, [_vm._v("联系电话：022-25636070")]), _vm._v(" "), _c('p', {
    staticClass: "email"
  }, [_vm._v("管家邮箱：gj@yunzhitupingtai.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-046faa99","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/custom.vue
// module id = 1254
// module chunks = 1